import { register } from "@shopify/theme-sections";
import $ from "jquery";

const selectors = {
	form: {
		wrapper: ".weiss-club-form",
		formbuilde: ".globo-formbuilder",
		submitButton: ".action.submit",
		inputList: ".weiss-club-form input",
		radioGenderWrapper: ".radio-wrapper",
		errorWrapper: ".has-error",
		checkboxWrapper: ".checkbox-wrapper",
		cancelButton: "[data-cancel-button]",
		checkboxArea: ".checkbox-area",
		timerField: 'input[value="timer"]',
		geburtstag: 'input[value="timer-geburtstag"]',
		noteField: 'input[value="data-js-change-value-hidden"]',
		birthtime: '[placeholder="Geburtstag"]'
	},
	metafieldForm: {
		form: "[data-metafield-change-form]"
	},
	loginForm: {
		form: "#customer_login",
		email: "#CustomerEmail",
		password: "#CustomerPassword"
	},
	errorMessage: {
		empty: "[data-error-empty]",
		email: "[data-error-email]",
		passwordValidate: "[data-error-password-validation]",
		passwordEqual: "[data-error-password-equal]"
	}
};

register("weiss-club", {
	isLogin: false,
	customerPrefillInformation: window.weissClubCustomerPrefill,
	hiddenNoteLabels: ["Titel", "Adelstitel"],
	genderCheckbox: ["Herr", "Frau"],
	onLoad: function () {
		setTimeout(() => {
			this.isLogin =
				$(selectors.form.wrapper).attr("data-customer-id").length > 0
					? true
					: false;
			this.initListeners();
			this.updateForm();
			this.initFillingUserFields();
		}, 2000);
	},

	updateCustomerNote: function () {
		const formContainer = this.container.querySelector(
			selectors.form.formbuilde
		);

		if (!formContainer) {
			return null;
		}

		const formID = formContainer?.dataset?.id;
		const appForms = window.Globo?.FormBuilder?.forms;

		if (!formID || !appForms) {
			return null;
		}
		let newStringWithParam = "";

		let checkboxes = formContainer.querySelectorAll('[type="radio"]');

		let genderCheckboxes = Array.from(checkboxes).filter((el) =>
			this.genderCheckbox.includes(el.value)
		);
		let selectedGenderCheckbox = genderCheckboxes?.find(
			(radio) => radio.checked
		);
		console.log("selectedGenderCheckbox", selectedGenderCheckbox);
		if (selectedGenderCheckbox) {
			newStringWithParam +=
				"gender" + ": " + selectedGenderCheckbox.value + "\r\n";
		}

		const elements = appForms[formID].elements;
		const filteredArray = [
			...elements.filter((item) =>
				this.hiddenNoteLabels.includes(item.label)
			)
		];

		filteredArray.forEach((el) => {
			let formFieldID = formID + "-" + el.id;
			let formField = document.getElementById(formFieldID);

			if (formField) {
				newStringWithParam +=
					el.label + ": " + formField.value + "\r\n";
			}
		});

		return newStringWithParam;
	},

	getCheckboxGender: function () {},
	getBirthdate: function () {
		const formContainer = this.container.querySelector(
			selectors.form.formbuilde
		);

		if (!formContainer) {
			return "";
		}

		const birthField = formContainer.querySelector(
			selectors.form.birthtime
		);

		if (!birthField) {
			return "";
		}

		return birthField.value;
	},

	initListeners: function () {
		$(selectors.form.submitButton).on("click", (event) => {
			event.preventDefault();
			const timerField = $(selectors.form.timerField);
			const geburtstagField = $(selectors.form.geburtstag);
			const hiddenNoteField = $(selectors.form.noteField);

			let stringOfNotes = this.updateCustomerNote();
			let birthtime = this.getBirthdate();

			const date = new Date();
			const options = {
				year: "numeric",
				month: "2-digit",
				day: "numeric",
				timezone: "UTC"
			};

			const localeDate = date
				.toLocaleString("de-DE", options)
				.replaceAll(".", "-")
				.replaceAll("/", "-");

			geburtstagField.attr("value", "Geburtstag: " + birthtime + "\r\n");
			timerField.attr("value", "Antragsdatum: " + localeDate + "\r\n");
			hiddenNoteField.attr("value", stringOfNotes);

			$(selectors.form.submitButton).unbind();
			$(selectors.form.submitButton).trigger("click");
		});

		$(selectors.form.inputList).each((_, input) => {
			let label = null;
			if ($(input.labels).length) {
				label = $(input.labels[0]);
			} else {
				return;
			}
			$(input).on("focus", () => {
				if (!$(label).hasClass("active")) {
					$(label).addClass("active");
				}
			});
			$(input).on("focusout", () => {
				if ($(input).val().length) {
					$(input).addClass("active-input");
				}
				if (!$(input).val().length && $(label).hasClass("active")) {
					$(label).removeClass("active");
				}
			});
		});
		$(selectors.form.cancelButton).on("click", (e) => {
			if ($(e.target).attr("data-cancel-link")) {
				document.location.href = `${window.location.origin}${$(
					e.target
				).attr("data-cancel-link")}`;
			}
		});
		$(selectors.form.radioGenderWrapper).on(
			"click",
			({ currentTarget }) => {
				const currentRadio = $(currentTarget).find("input");
				if ($(currentRadio).attr("checked")) return;
				$(currentRadio).attr("checked", "true");
				$(selectors.form.radioGenderWrapper).each((_, item) => {
					if (
						item !== currentTarget &&
						$(item).find("input").attr("checked")
					) {
						$(item).find("input").removeAttr("checked");
					}
				});
			}
		);
	},
	updateForm: function () {
		let checkboxInputs = $(selectors.form.checkboxWrapper).find(
			'[data-type="checkbox"]'
		);
		checkboxInputs.each((_, element) => {
			$(element.labels[0]).addClass("red-line");
		});
	},

	initFillingUserFields: function () {
		if (!this.isLogin) return;
		// Fill customer fields
		this.customerPrefillInformation.forEach(
			({ placeholder, input_type, editable_field }) => {
				const currentInput = $(`[placeholder="${placeholder}"]`);
				const customerInfo = window.customer[`${input_type}`];
				const inputId = currentInput.attr("id");
				// Gender
				if (input_type === "gender") {
					const genders = placeholder.split(",").map((gender) => {
						return {
							ge: gender.split("|")[0].toLowerCase().trim(),
							en: gender.split("|")[1].toLowerCase().trim()
						};
					});
					const genderLabels = $(
						`${selectors.form.radioGenderWrapper} label`
					);
					genderLabels.each((_, label) => {
						genders.forEach((gender) => {
							if (
								$(label).text().toLowerCase().trim() ===
									gender.ge &&
								(gender.en ===
									window.customer.gender.toLowerCase() ||
									gender.ge ===
										window.customer.gender.toLowerCase())
							) {
								$(label.control).trigger("click");
							}
						});
					});
				} else if (
					currentInput &&
					customerInfo &&
					customerInfo.length
				) {
					currentInput
						.val(customerInfo)
						.attr("readonly", !editable_field)
						.attr("disabled", !editable_field)
						.addClass("active-input");
					$(`label[for="${inputId}"]`).length
						? $(`label[for="${inputId}"]`).addClass("active")
						: null;
				}
			}
		);
	}
});
